import React from "react";
import clsx from "clsx";
import { useIntl } from "react-intl";
import { svgIcon } from "../../utils/svgProvider";

export const ClubBenefits = ({ target }) => {
	const [isAnimationDone, setIsAnimationDone] = React.useState(false);
	const { formatMessage } = useIntl();

	React.useEffect(() => {
		const timer = setTimeout(() => {
			setIsAnimationDone(true);
		}, 300);

		return () => {
			clearTimeout(timer);
		};
	}, []);

	return (
		<div
			className={clsx({
				"club-benefits-wrapper": true,
				show: isAnimationDone,
				sidebar: target === "sidebar",
			})}
		>
			<h4>
				{formatMessage({
					id: "komid.register.club.title",
				})}
			</h4>
			<h2>{formatMessage({ id: "komid.register.club.subtitle" })}</h2>
			<ul>
				<li>
					{svgIcon.clubCheck}
					<span>
						{formatMessage({ id: "komid.register.club.freeofcharge" })}
					</span>
				</li>
				<li>
					{svgIcon.clubCheck}
					<span>
						{formatMessage({ id: "komid.register.club.discountforpurchase" })}
					</span>
				</li>
				<li>
					{svgIcon.clubCheck}
					<span>
						{formatMessage({ id: "komid.register.club.exclusivebenefits" })}
					</span>
				</li>
				<li>
					{svgIcon.clubCheck}
					<span>
						{formatMessage({ id: "komid.register.club.prioritysupport" })}
					</span>
				</li>
			</ul>
		</div>
	);
};
